export default __webpack_public_path__ + "static/media/SEC1440.34I-32569_-26075_0.b45899f6.jpg";